import {UserAvatar} from '@frontend/components/UserAvatar'
import {trans} from '@frontend/helpers'
import {
    mdiCheckAll,
    mdiPaperclip,
} from '@mdi/js'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'
import type {ChatMessageData} from '../ChatsModuleTypes'

interface Props {
    message: ChatMessageData
    // Мобильная раскладка независимо от ширины экрана.
    miniChat?: boolean
}

// Элемент сообщения в чате.
export function ChatMessagesListItem(props: Props) {

    const {
        message,
        miniChat,
    } = props

    const renderMessage = () => {
        if (message.file) {
            if (message.file.type === 'image') {
                return (
                    <div className="pt-2">
                        <Link
                            to={message.file.url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src={message.file.url}
                                alt=""
                                width={200}
                                className="mb-2 rounded-4"
                            />
                        </Link>
                        {message.message.length > 0 && (
                            <div className="mt-n1 text-multiline">
                                {message.message}
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div>
                        <a
                            href={message.file.url}
                            target="_blank"
                            className="with-icon"
                            rel="noreferrer"
                        >
                            <Icon
                                path={mdiPaperclip}
                                color="muted"
                                className="me-2"
                            />
                            <span>{message.file.name}</span>
                        </a>
                        {message.message.length > 0 && (
                            <div className="mt-1 text-multiline">
                                {message.message}
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="text-multiline">
                    {message.message}
                </div>
            )
        }
    }

    const bubble = (
        <div
            className={clsx(
                'chat-message-text position-relative p-3 rounded-8',
                message.isAuthor ? 'bg-light-blue' : 'chat-surface'
            )}
        >
            {renderMessage()}
            {!message.isAuthor && !message.isViewed && (
                <Badge
                    dot
                    color="red"
                />
            )}
        </div>
    )

    const timestamp = (
        <div className="text-muted fs-7 text-nowrap">
            {message.createdAtTime}
        </div>
    )

    const viewedIcon = (
        <Icon
            path={mdiCheckAll}
            size={16}
            color="light-green"
        />
    )

    // На мобильном время и отметка о прочтении уходят под сообщение.
    if (message.isAuthor) {
        return (
            <div className="chat-message d-flex flex-column align-items-end gap-1 mb-3 ps-5">
                <div className="d-flex flex-row align-items-center gap-2">
                    <div className={clsx('d-none', !miniChat && 'd-sm-block')}>
                        {timestamp}
                    </div>
                    {bubble}
                    {message.isViewed && (
                        <div className={clsx('d-none', !miniChat && 'd-sm-flex')}>
                            {viewedIcon}
                        </div>
                    )}
                </div>
                <div className="d-flex flex-row align-items-center gap-2 text-muted fs-7">
                    <div className={clsx(!miniChat && 'd-sm-none')}>
                        {timestamp}
                    </div>
                    {message.isViewed && (
                        <>
                            {trans().cabinet.chats.message_read}
                            <div className={clsx('d-flex', !miniChat && 'd-sm-none')}>
                                {viewedIcon}
                            </div>
                        </>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div
            className={clsx(
                'chat-message d-flex gap-2 mb-3 pe-5',
                'flex-column align-items-start',
                !miniChat && 'flex-sm-row align-items-sm-center'
            )}
        >
            {!miniChat && (
                <UserAvatar
                    userName={message.user.name}
                    className="flex-shrink-0"
                />
            )}
            {bubble}
            <div className={clsx('align-self-start', !miniChat && 'align-self-sm-center')}>
                {timestamp}
            </div>
        </div>
    )
}
